<script>
	import { onMount, onDestroy } from "svelte";
	import * as L from "leaflet";
	const groundInactiveIcon = '/images/grs-inactive.png';
	const groundRegisteredIcon = '/images/grs-registered.png';
	const grsImg = '/images/grs-map.png';

	export let device;
	export let layer;
	export let active = false;

	let marker;

	$: updateMarker(device)

	onMount(() => {
		marker = L.marker([0, 0]);
		updateMarker(device);
		marker.addTo(layer);
	});

	onDestroy(() => {
		if (!marker) return;
		marker.removeFrom(layer);
	});

	function getIcon() {
		if (active)	return grsImg
		if (device.state === "DISCONNECTED") return groundInactiveIcon
		return groundRegisteredIcon
	}

	function getClassName() {
		if (!active) return ''

		let className = "grs-map"
		// TODO: factor in GRS truancy
		switch (device.remoteRadioStatus) {
			case -1:
				className += " error"
				break;
			case 0:
				className += " no-signal"
		}

		return className
	}

	function updateMarker(device) {
		if (!marker) return;
		marker.setLatLng([device.latitude, device.longitude]);
		let popup = device.name
		if (device.status) {
			popup += `<br>${device.status}`
		}
		marker.bindPopup(popup);
		marker.setIcon(
			L.icon({
				iconUrl: getIcon(),
				iconSize: [25, 25],
				iconAnchor: [12.5, 12.5],
				className: getClassName()
			})
		);
	}
</script>
